var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M7.9,21.9v1.3h3.7l5.4-2.7h2.3V21c0,0.3,0,0.5,0.1,0.8h-2.3l-5.1,9.1l-3.2,0.6l0.2,1.2l3.8-0.7l5-8.9h1.8 c0.1,0.4,0.2,0.8,0.4,1.2c-0.6,0.1-1.2,0.4-1.7,0.8c-0.9,1-1.3,2.4-1.2,3.7c0,3.2,2.6,8.7,5.2,8.7c1-0.1,1.9-0.6,2.5-1.4 c1.9-2,3-4.6,3.2-7.3c-0.1-3-1.4-4.1-2.9-4.5c0.2-0.4,0.3-0.8,0.5-1.3h1.6l5.1,8.9l3.8,0.7l0.2-1.2l-3.2-0.6l-5.2-9h-2.2 c0.1-0.3,0.1-0.6,0.1-0.9v-0.4h2.3l5.4,2.7h3.7v-1.3h-3.4l-5.4-2.6h-2.7l-0.3-0.9h2.4l5.2-5.1l3.3-0.6l-0.2-1.2L32.3,12l-5.1,5 h-2.3c1.1-0.4,1.8-1.5,1.7-2.7c-0.1-1.1-0.5-2.2-1.3-3c0.4-1.3,0.1-2.7-0.8-3.7l-0.9,0.8c0.3,0.5,0.5,1.1,0.6,1.7 c-0.5-0.3-1-0.5-1.6-0.6c-0.7,0.1-1.4,0.3-1.9,0.8c0-0.7,0.2-1.4,0.7-1.9l-0.9-0.9c-0.9,1-1.3,2.5-0.9,3.8c-0.8,0.8-1.2,1.9-1.3,3 c0,1.2,0.7,2.2,1.8,2.7h-2.5l-5-5l-3.7-0.7l-0.3,1.3l3.4,0.6l5.1,5h2.5l-0.3,1h-2.7l-5.5,2.6H7.9z M26.6,28.9 c-0.1,2.4-1.1,4.7-2.8,6.4c-0.4,0.5-1,0.9-1.6,1c-1.4,0-3.9-4.3-3.9-7.4c-0.1-1,0.2-2.1,0.8-2.9c0.7-0.5,1.5-0.7,2.3-0.6h1.2 C24.6,25.4,26.6,25.4,26.6,28.9z M23.6,24l-1,0.1h-1.3c-0.6-1-0.8-2.1-0.8-3.2c0-1.3,0.4-2.6,1.2-3.6h1.6c0.8,1,1.3,2.2,1.2,3.5 C24.6,22,24.3,23.1,23.6,24z M19.6,14.4c0.1-0.9,0.5-1.8,1.2-2.4c0.5-0.6,1.1-0.9,1.8-1.1c1.1,0,2.8,2.1,2.8,3.5 c0,1.4-1,1.8-2.8,1.8S19.6,15.7,19.6,14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M25.4,14.4c0-1.4-1.7-3.5-2.8-3.5c-0.7,0.2-1.3,0.5-1.8,1.1c-0.7,0.6-1.1,1.5-1.2,2.4c0,1.3,1.2,1.8,3,1.8 S25.4,15.7,25.4,14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M21.4,25.4c-0.8-0.1-1.6,0.1-2.3,0.6c-0.6,0.8-0.9,1.9-0.8,2.9c0,3.1,2.5,7.4,3.9,7.4 c0.6-0.1,1.2-0.5,1.6-1c1.7-1.7,2.7-4,2.8-6.4c-0.1-3.5-2-3.5-4-3.5H21.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M23.4,17.4h-1.6c-0.8,1-1.2,2.3-1.2,3.6c0,1.1,0.2,2.2,0.8,3.2h1.3l1-0.1c0.6-0.9,1-2.1,0.9-3.2 C24.6,19.6,24.2,18.3,23.4,17.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnt);
export default __webpack_public_path__ + "static/media/ant.3c3b9e6d4bc2094464000542f9a1b0bf.svg";
export { ForwardRef as ReactComponent };